import {
  Box,
  Icon,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import "cropperjs/dist/cropper.css";
import { forwardRef, useState } from "react";
import { Cropper, ReactCropperElement, ReactCropperProps } from "react-cropper";
import { LuImageMinus, LuImagePlus } from "react-icons/lu";

export interface ImageCropperProps extends ReactCropperProps {
  image: string;
  showZoomSlider?: boolean;
}
export const ImageCropper = forwardRef<ReactCropperElement, ImageCropperProps>(
  function ImgCropper({ image, ...props }, ref) {
    const [zoomValue, setZoomValue] = useState(0);

    return (
      <>
        <Cropper
          ref={ref}
          style={{ height: 400, width: "100%" }}
          zoomTo={zoomValue}
          initialAspectRatio={1 / 1}
          preview=".img-preview"
          src={image}
          viewMode={1}
          {...props}
        />
        <Box
          sx={{
            mt: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            fontSize: "1.5rem",
          }}
        >
          <Icon as={LuImageMinus} />
          <Slider
            flex={1}
            colorScheme="primary"
            min={0}
            max={1}
            onChange={(val) => setZoomValue(val)}
            step={0.1}
            value={zoomValue}
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb boxSize="1rem" />
          </Slider>
          <Icon as={LuImagePlus} />
        </Box>
      </>
    );
  },
);
